import styled from 'styled-components';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  width: 100%;
`;

export const Typography = styled(TextLayoutComponent.Title)`
  margin: 40px 0;
  text-align: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 200px;
  justify-content: space-evenly;
  margin-bottom: 100px;
  padding: 10px;
  width: 800px;
`;

export const DownloadContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const Image = styled.img`
  height: 90px;
  width: 90px;
`;

export const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    margin-top: 20px;
    width: 170px;
  }
`;

export const DownloadLink = styled.button`
  all: unset;
  margin-top: 10px;
  font-weight: 500;
  padding: 5px;
  color: #477ae9;
  cursor: pointer;

  &:hover {
    color: #1954d3;
  }
`;

export const TutorialLink = styled.a``;

export const HelpMessage = styled(TextLayoutComponent)`
  padding: 20px 10px;
  font-size: 14px;
  text-align: center;
`;
